import { KeyValue } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ControlContainer, FormArray, FormGroup } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { SoilClassificationMapper } from '@mappers/soil-classification-mapper';
import { SoilQualityTypeService } from '@mappers/soil-quality-type/soil-quality-type.service';
import {
  EditFillSiteSoilQualityTypeViewModel,
  FillSiteSoilQualityTypeViewModel,
  SiteClassificationType,
  SoilQualityType,
  VisibilityToClients
} from '@services/cleanfill-api/cleanfill-api.generated';
import { IAddress } from '@services/cleanfill-core/address-service/address.model';
import { CountryStoreService } from '@services/cleanfill-core/country-service/country-store.service';
import { SiteType } from '@view-models/enums/site-type.enum';

@Component({
  selector: 'receiving-site-info',
  templateUrl: './receiving-site-info.component.html',
  styleUrls: ['./receiving-site-info.component.scss']
})
export class ReceivingSiteInfoComponent implements OnInit {
  @Output() addSite = new EventEmitter();
  sites: FormArray;
  SiteType = SiteType;
  SoilQualityType = SoilQualityType;
  SiteClassificationType = SiteClassificationType;
  VisibilityToClients = VisibilityToClients;
  tabIndex = 0;
  get formGroup() {
    return this.formRef ? this.formRef.control : null;
  }
  get address() {
    return this.sites.at(this.tabIndex).get('address') as FormGroup;
  }
  get soilQualityTypes() {
    return this.sites
      .at(this.tabIndex)
      .get('soilQualityTypes')
      ?.value.map(v => v.soilQualityType);
  }
  constructor(
    public formRef: ControlContainer,
    public countryStoreService: CountryStoreService,
    public soilQualityService: SoilQualityTypeService,
    public soilClassificationMapper: SoilClassificationMapper
  ) {}

  ngOnInit(): void {
    this.sites = (this.formGroup as FormGroup).get('sites') as FormArray;
  }

  tabChanged(newTab: MatTabChangeEvent) {
    this.tabIndex = newTab.index;
  }
  addTab() {
    this.addSite.emit();
  }
  outputAddressDetailsEvent(addressDetails: IAddress) {
    this.address.patchValue({
      line1: addressDetails.line1 + addressDetails.line2,
      provinceUniqueId: addressDetails.provinceId,
      city: addressDetails.city,
      postalCode: addressDetails.postalCode
    });
  }

  toggleSoilQualityType(selected: KeyValue<string, SoilQualityType>) {
    const formControl = this.sites.at(this.tabIndex).get('soilQualityTypes');
    const changeArrRef = formControl.value.slice();
    const index = changeArrRef.findIndex(v => v.soilQualityType === selected.value);

    index === -1
      ? changeArrRef.push(new FillSiteSoilQualityTypeViewModel({ soilQualityType: selected.value }))
      : changeArrRef.splice(index, 1);

    formControl.setValue(changeArrRef);
  }
  toggleSoilQuality(type: SoilQualityType): void {
    const formControl = this.sites.at(this.tabIndex).get('soilQualityTypes');
    let soilQualities = formControl.value?.slice() as EditFillSiteSoilQualityTypeViewModel[];

    const index = soilQualities.findIndex(soilQuality => soilQuality.soilQualityType === type);
    if (type === SoilQualityType.AllSoilTypes) {
      const soilQualityTypes = Object.keys(SoilQualityType).map(
        key => new EditFillSiteSoilQualityTypeViewModel({ soilQualityType: SoilQualityType[key] })
      );
      index === -1 ? (soilQualities = soilQualityTypes) : (soilQualities = []);
      formControl.setValue(soilQualities);
    } else {
      index === -1
        ? soilQualities.push(new EditFillSiteSoilQualityTypeViewModel({ soilQualityType: type }))
        : soilQualities.splice(index, 1);
      formControl.setValue(soilQualities);
    }
  }

  toggleSiteClassificationType(selected: KeyValue<string, SiteClassificationType>) {
    const formControl = this.sites.at(this.tabIndex).get('siteClassificationType');
    formControl.setValue(selected.value);
  }
}
